import { getNames } from 'country-list'

const countries = getNames().map((country) => ({
  label: country,
  value: country,
}))

export { countries }
